import { useEffect, useState } from 'react';

interface UseBrowserCookieNoticeStateOptions {
    version: number;
    localStorageKey?: string;
}

export function useBrowserCookieNoticeState ({ version, localStorageKey = 'cookieNotice' }: UseBrowserCookieNoticeStateOptions) {
    const [showNotice, setShowNotice] = useState(false);

    useEffect(() => {
        const hideCookieNotice = localStorage.getItem(localStorageKey);
        if (hideCookieNotice !== `${version}`) {
            setShowNotice(true);
        }
    }, []);

    const handleClose = () => {
        setShowNotice(false);
        localStorage.setItem(localStorageKey, `${version}`);
    };

    return {
        shouldShow: showNotice,
        close: handleClose
    };
}
